// TODO: replace w/ copy in @waterly/utils
export default (param?: unknown): param is string | number =>
  !isNaN(parseFloat(String(param))) && isFinite(Number(param));
